import { FeatureFlags } from "@utils/FeatureFlags/generated-flags";
import { useFlags } from "launchdarkly-react-client-sdk";

import { ApiReportReportTypeChoices } from "@api/graphql/types-and-hooks";
import { useReportOptional } from "@providers/ReportProvider";

export const useIsQaScannerEnabled = (): boolean => {
  const flags = useFlags<FeatureFlags>();
  const reportData = useReportOptional();
  const reportType = reportData?.report.reportType;

  return !!(
    (reportType === ApiReportReportTypeChoices.InitialAssessment && flags["ia-report-qa-scanner"]) ||
    (reportType === ApiReportReportTypeChoices.Reassessment && flags["reassessment-report-qa-scanner"]) ||
    (reportType === ApiReportReportTypeChoices.DiagnosisEvaluation &&
      reportData?.viewMode === "single" &&
      flags["db-single-page"] &&
      flags["db-report-qa-scanner"])
  );
};
